export default "__VITE_ASSET__hZkLjCjP__"